import { Company, Office, CompanyType } from "@/api/company-api";

export default function createCompany(): [Company, Office] {
  const office = {
    companyId: "",
    officeId: "",
    name: "",
    mail: "",
    tel1: "",
    tel2: "",
    fax: "",
    postcode: "",
    address: "",
    latitude: 0,
    longitude: 0,
    note: "",
    cutoffRule: 31,
    monthRule: 1,
    dayRule: 31,
    staffList: [],
    stampList: [],
    bankAccounts: [],
    profitRate: 0.2
  };
  const company = {
    office,
    companyId: "",
    companyTypeId: CompanyType.Corporation,
    name: "",
    furigana: "",
    client: false,
    vendor: false,
    family: false
  };
  return [company, office];
}
